import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { posGet, esMaster } from "./posApi";

const CLAVE = "pos-tienda";

// Tienda activa: el usuario de tienda siempre ve la suya; el master elige (se recuerda).
export const useTienda = (permiteTodas = false) => {
  const { user } = useContext(AuthContext);
  const master = esMaster(user);
  const [tiendas, setTiendas] = useState([]);
  const [tienda, setTiendaState] = useState(() => {
    try { return localStorage.getItem(CLAVE) || ""; } catch (e) { return ""; }
  });

  useEffect(() => {
    if (!user || !user.rolTiendas) return;
    posGet("/tiendas", { activas: "Si" })
      .then((t) => {
        setTiendas(t);
        if (!master) setTiendaState(t[0] ? t[0]._id : "");
        else {
          // La recordada ya no existe o se desactivó: se olvida
          const vigente = tienda && tienda !== "todas" && t.some((x) => x._id === tienda) ? tienda : "";
          if (!vigente && tienda && tienda !== "todas") { try { localStorage.removeItem(CLAVE); } catch (e) { /* sin storage */ } }
          if (!vigente) setTiendaState(permiteTodas ? "" : t[0] ? t[0]._id : "");
        }
      })
      .catch(() => setTiendas([]));
  }, [user && user.rolTiendas]); // eslint-disable-line

  const setTienda = (id) => {
    setTiendaState(id);
    try { if (id !== "todas") localStorage.setItem(CLAVE, id); } catch (e) { /* sin storage */ }
  };

  const actual = tiendas.find((t) => t._id === tienda);
  const valor = master ? (permiteTodas ? tienda || "todas" : tienda) : actual ? actual._id : "";
  return { tiendas, tienda: valor, setTienda, master, nombreTienda: actual ? actual.name : valor === "todas" ? "Todas las tiendas" : "" };
};

export const TiendaSelector = ({ ctx, permiteTodas = false, label = "Tienda" }) => {
  const { tiendas, tienda, setTienda, master, nombreTienda } = ctx;
  if (!master) {
    return (
      <div>
        <label className="mb-0">{label}</label>
        <div style={{ fontWeight: 700, padding: "6px 0" }}>
          <i className="fas fa-store mr-2" style={{ color: "#10b981" }} />
          {nombreTienda || "—"}
        </div>
      </div>
    );
  }
  return (
    <div style={{ minWidth: 220 }}>
      <label className="mb-0">{label}</label>
      <select className="form-control" value={tienda} onChange={(e) => setTienda(e.target.value)}>
        {permiteTodas ? <option value="todas">Todas las tiendas</option> : <option value="">Selecciona…</option>}
        {tiendas.map((t) => (
          <option key={t._id} value={t._id}>{t.clave ? `${t.clave} · ` : ""}{t.name}</option>
        ))}
      </select>
    </div>
  );
};
